module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_FolderOpen_16"],"path":[{"$":{"d":"M1,10.36V2H7L9,4h5V6H2.25ZM3,7,1,14H14l2-7Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_FolderOpen_16.svg
// module id = 6NRI
// module chunks = 1